import axios from "axios";
import { Message } from "element-ui";
let uploadUrl = `${process.env.BASE_URL}/upload/stsToken`;
let OSS = require("ali-oss");
let ossObj = {};

// 获取阿里云数据
function getAliyun() {
  return axios.get(uploadUrl).then(function(response) {
    ossObj = response.data.data;
  });
}

async function uploadOSS(event, path) {
  try {
    await getAliyun();
    let client = new OSS({
      region: ossObj.region,
      accessKeyId: ossObj.accessKeyId,
      accessKeySecret: ossObj.accessKeySecret,
      stsToken: ossObj.stsToken,
      bucket: "68wx--test"
    });
    let dir = `${path}/${event.file.name}`;
    //object-name可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    //   let result = await client.multipartUpload(dir, event.File);
    let result = await client.multipartUpload(dir, event.file);
    if (result.res.status == 200) {
      return result.res.requestUrls[0].split("?")[0];
    } else {
      Message.error("上传失败");
    }
    //   return
  } catch (e) {
    console.log(e);
  }
}

export { uploadOSS };



// WEBPACK FOOTER //
// ./src/upload/upload.js